<template>
  <div>

    <div class="byBox sort">
      <div class="firstDes">
       <span class="fontB" style="margin-left: 132px">Density:</span>

       <div
        class="grayBtn sortBtn"
        v-for="item in Density"
        :key="item.val"
        @click="sortDensity(item.val)"
        :class="
          getProportion == item.val || curDensity == item.val
            ? 'blueBtnW'
            : 'grayBtnW'
        "
      >
        {{ item.title }}
      </div>
      </div>
      <div>
      <span class="fontB" style="margin-left: 135px">Sort  by:</span>
      <div
        class="grayBtn sortBtn"
        v-for="item in sortList"
        :key="item.val"
        @click="sortOrderBy(item.val)"
        :class="
          curOrderBy == item.val
            ? 'blueBtnW'
            : 'grayBtnW'
        "
      >
        {{ item.title }}
      </div>
      </div>
    </div>
    <div class="total">
        <!-- <p v-if="partInfo.total" >Shipment total: {{partInfo.total.sumUnit}} Unit {{InterceptUnit(partInfo.total.sumKG,3)}} KG {{InterceptUnit(partInfo.total.sumCBM,4)}} CBM {{InterceptUnit(partInfo.total.sumLB,3)}}LB {{InterceptUnit(partInfo.total.sumCFT,4)}} CFT</p>
        <p v-else-if="!partInfo.total">Shipment total: {{queryParma.TotalQuanlity}} Unit {{InterceptUnit(queryParma.TotalWeight,3)}} KG {{InterceptUnit(queryParma.TotalCBM,4)}} CBM {{InterceptUnit(queryParma.TotalWeight * 2.2046226,3)}}LB {{InterceptUnit(queryParma.TotalCBM * 35.3147248,4)}} CFT</p>
       -->
       <p v-if="sumList">Shipment total: {{sumList.total.sumUnit}} Unit {{InterceptUnit(sumList.total.sumKG,3)}} KG {{InterceptUnit(sumList.total.sumCBM,4)}} CBM {{InterceptUnit(sumList.total.sumLB * 2.2046226,3)}}LB {{InterceptUnit(sumList.total.sumCFT * 35.3147248,4)}} CFT</p>
       <span v-else>
       <p v-if="partInfo.total" >Shipment total: {{partInfo.total.sumUnit}} Unit {{InterceptUnit(partInfo.total.sumKG,3)}} KG {{InterceptUnit(partInfo.total.sumCBM,4)}} CBM {{InterceptUnit(partInfo.total.sumLB,3)}}LB {{InterceptUnit(partInfo.total.sumCFT,4)}} CFT</p>
        <p v-else-if="!partInfo.total">Shipment total: {{queryParma.quantity}} Unit {{InterceptUnit(queryParma.weight,3)}} KG {{InterceptUnit(queryParma.volume,4)}} CBM {{InterceptUnit(queryParma.weight * 2.2046226,3)}}LB {{InterceptUnit(queryParma.volume * 35.3147248,4)}} CFT</p>
        </span>
        
    </div>
    <div class="list clear">
      <div class="list-l l byBox">
        <data-left
          @getarrivalType='getarrivalType'
          :startAirport="startAirportCodeList"
          :endAirport="destAirportCodeList"
          :thWorkDays="result.lstThWorkDays"
          :parmaData="queryParma"
          :result="result"
          @sort="handleLeft"
          @newList="getNewList"
          :isCheckSortBy="isCheckSortBy"
        />
      </div>
      <div class="list-r l"><!---->
        <res-table
          v-show="result.List.length"
          :feeData="result.List"
          :newList='newList'
          :parmaData="queryParma"
          :cargoData="cargoData"
          :curDensity='curDensity'
          :getProportion='getProportion'
          :getKg='getKg'
          :sumList='sumList'
          :tiaoshu="tiaoshu1"
          :isCheckSortBy="isCheckSortBy"
          @choseItem="getNewList"
          
          ref="child"
        />
        <div class="listDataNone" v-show="!result.List.length">
        <div class="textNone" >
          <div class="empty-box">
            <img src="/static/img/fyImg/empty.png" width="167px" height="134px" />
            <p>No quotation found at moment,please contact our custom service to inquiry case by case.</p>
          </div>
          <!-- <p class="marBot10"><i class="fa fa-cry" style="font-size:60px;color:#d3d3d3"></i> </p> -->
          <!-- <p style="color:#9B9B9B">{{queryParma.IsSHReport=== false ? 'For internal/distribution cargo, please inquire the price for departure from Hong Kong.' : 'There is no real-time quote for Freightshop, you can contact customer service.'}}</p> -->
        </div>
        </div>
      </div>
    </div>
    <div class="textC" v-if="newList.length>10 && showMoreList" style="height: 50px;line-height: 50px;margin-left: 140px;">
                <div class="circle"></div>
                <div class="text">
                <span class="moreClass" >

                 <a @click="() =>{
                   showStow = showStow ? false :true
                   tiaoshu1 = showStow ? 10 :newList.length
                   }" style="color: #004fb1" v-if="tiaoshu1 >= 10">
									{{(showStow == true) ? 'more':'stow'}}<i :class='showStow?"fa fa-arrDown colBlue":"fa fa-arrowUp colBlue"' style="margin-top: 1px"></i>
								</a>
              </span>
                </div>
            </div>
    <!-- <div v-if="result.List.length>=20">
      <el-pagination
        style="margin: 10px 0 20px 0"
        class="textC"
        background
        @current-change="handleCurrentChange"
        :current-page.sync="currentPage"
        :page-size="10"
        layout="total, prev, pager, next"
        :total="result.Total"
      >
      </el-pagination>


    </div> -->
  </div>
</template>
<script>
import dataLeft from "./dataLeft";
import resTable from "./resTable.vue";
import { post, fetch, Del, put } from "@/ask/axios";
import  EventBus  from "@/ask/eventBus";
export default {
  name: "airResult",
componentName:"airResult",
  props: {
    queryParma:{ type: Object, default: {} },

    result: { type: Object, default:  {
      startAirportCodeList: [],
      destAirportCodeList: [],
      lstThWorkDays: [],
      List: []
    }},
    cargoData: Array,
    sumList:Object,
    isCheckSortBy:Boolean,
  },

  components: { dataLeft, resTable },
  data() {
    return {
      feeList: [], //报价详情展开[]代表没有展开
      curOrderBy: this.queryParma.OrderBy ?this.queryParma.OrderBy:'price',
      currentPage: Math.floor(this.queryParma.Skip / 10) + 1,
      curDensity:'',
      startAirportCodeList: [],
      destAirportCodeList: [],
      sortList:  [
        {
          title: "Comprehensive",
          val: "comprehensive",
        },
        {
          title: "Cheapest",
          val: "price",
        },
        {
          title: "Top-selling",
          val: "expsale",
        },
        {
          title: "Quickest",
          val: "workday",
        },
      ],
         Density:  [
        {
          title: "General",
          val: "General",
        },
        {
          title: "1:300",
          val: "1:300",
        },
        {
          title: "1:500",
          val: "1:500",
        },
        {
          title: "1:1000",
          val: "1:1000",
        },
      ],
      partInfo:[],
      showMore:true,
      tiaoshu1:10,
      showMoreList:true,
      showStow:true,
     
      newList:this.result.List,//左侧筛选之后新的集合
      destlist:[],//左侧栏存储
      linelist:[],
      arrivalType:0,

    };
  },
  created() {
    if( this.queryParma.destAirportCodeList.length ) {
      this.startAirportCodeList =  this.result.Origin
      this.destAirportCodeList =  this.result.Dest
    }
  },
  mounted(){
    EventBus.$on("aMsg", (msg) => {
      this.partInfo=msg;
    })
  },

  computed:{
    getProportion() {
      this.curDensity='';
      let Kg,CBM;
      
      if(this.partInfo!=0){
          Kg=this.partInfo.total.sumKG;
          CBM=this.partInfo.total.sumCBM;
      }else{
          Kg=this.queryParma.Weight?this.queryParma.Weight:this.queryParma.weight;
          CBM=this.queryParma.Volume?this.queryParma.Volume:this.queryParma.volume;
      }
      let weight=this.InterceptUnit((Kg / CBM), 3);
      if(weight<300){
        return 'General'
      }else if(weight>=300 && weight<500){
        return '1:300'
      }else if(weight>=500 && weight<1000){
        return '1:500'
      }else {
        return '1:1000'
      }
      //return this.InterceptUnit((Kg / CBM), 3)
    },
    getKg(){
          let Kg;
          if(this.partInfo!=0){
          Kg=this.partInfo.total.sumKG;
          }else{
          Kg=this.queryParma.weight;
          }
          if(Kg>0 && Kg<100){
          return '45'
          }else
          if(Kg>=100 && Kg<300){
            return '100'
          }else if(Kg>=300 && Kg<500){
            return '300'
          }else if(Kg>=500 && Kg<1000){
            return '500'
          }else{
            return '1000'
          }

    }
  },

  methods: {
    getarrivalType(val){
      
      this.arrivalType =val;
     
    },
    getNewList(item){
     // console.log("====this.newList=====",this.newList,this.result);
      this.newList = item
      if(this.newList.length>10){
        this.showStow=true;
        this.showMoreList =true;
        this.tiaoshu1 = 10
      }else{
        this.showMoreList =false;
      }
    },
    handleLeft(val) {
      
      this.destlist=val.startCode3
      this.linelist=val.airlineCode2
      this.arrivalType=val.arrivalType
      EventBus.$emit("checkEnquiry",val);//startCode3   airlineCode2
      // let parma = this.queryParma;
      // let { arrivalType, endCode3, startCode3, thDays ,airlineCode2} = val;
      // let airlineCode=[];
      // val.airlineCode2.filter(function (elem) {
      //   airlineCode.push(elem.Key)
      //     return airlineCode;
      // })
      // parma.startAirportCodeList = startCode3;
      // parma.destAirportCodeList = endCode3;
      // parma.arrivalType = arrivalType;
      // parma.lstThWorkDays = thDays;
      // parma.OrderBy = this.curOrderBy;
      // parma.airCompanyKeyList=airlineCode;
      //this.$emit("queryMethod", parma);
    },
     arrayforEach(array){
      let list = []
      if(array){
        array.filter(function (item) {
          list.push(item.Code)
          return list;
        })
      }
      return list
    },
    sortOrderBy(val) {
      this.curOrderBy = val;
      let parma = this.queryParma;
      parma.OrderBy = this.curOrderBy;
      //是否勾选了左侧内容
      if(this.linelist.length>0 || this.destlist.length>0 || this.arrivalType==1 ){
        parma.isResultBox = true
        parma.Alllist=this.newList
        parma.destlist=this.destlist.length>0?this.destlist:this.result.Origin
        parma.linelist=this.linelist.length>0?this.linelist:this.arrayforEach(this.result.Airline)
        parma.oldOrigin = this.result.Origin
        parma.oldAirline = this.result.Airline
        parma.arrivalType=this.arrivalType
      }
      this.$emit("queryMethod", parma);
    },
      arrayforEach(array){
      let list = []
      if(array){
        array.filter(function (item) {
          list.push(item.Code)
          return list;
        })
      }
      return list
    },
    
    sortDensity(val){
        let that=this;
        this.curDensity=val;
        if(val=='General'){
            val = 167;
        }else{
            var index=val.lastIndexOf("\:");
            val=val.substring(index+1,val.length);
        }
        let query={
            W:val,
            C:1
        }
        let parma = this.queryParma;
        parma.Volume=query.C;
        parma.Weight=query.W;
        parma.isResultBox = false
        that.$emit("queryMethod", parma);

        // setTimeout(function(){
        //   //this.curDensity=val;
        //   EventBus.$emit("query", query);
        // }, 300)
        
    },
 
    handleCurrentChange(val) {
          let parma = this.queryParma;
          parma.skip = (this.currentPage - 1) * 10;
          this.$emit("queryMethod", parma, "isSkip");
    },
  },
  destroyed(){
    EventBus.$off("aMsg");
  }
};
</script>
<style scoped>
.list-l {
  width: 120px;
  margin-right: 15px;
  margin-top: 27px;
}
.list-r {
  width: 1062px;
}
.sort {
  margin: 20px 0;
  padding: 13px 0;
}
.sortBtn {
  margin-left: 5px;
}
.blueBtn {
  border-radius: 30px;
  padding: 5px 10px;
  min-width: 60px;
  text-align: center;
  background: #004FB1;
  color: #fff !important;
}
.fontB {
  font-weight: bold;
  color: black;
}
.blueBtnW {
  border: 1px solid #004FB1;
  border-radius: 30px;
  width: 100px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: #004FB1;
  color: #fff !important;
  display: inline-block;
  cursor: pointer;
}
.grayBtnW {
  border: 1px solid #efefef;
  border-radius: 30px;
  cursor: pointer;
  width: 100px;
  height: 24px;
  line-height: 24px;
  text-align: center;
  background: #efefef;
  color: #666 !important;
  display: inline-block;
}
.listDataNone{height:160px;width:100%;}
.listDataNone .textNone{padding-top:55px;overflow:hidden}
.listDataNone p,.listDataNone p img{text-align:center;margin:auto;font-size:14px;color:#999;}
.firstDes{
  margin-bottom: 5px;
}
.total{
  margin: 0 0 10px 0;
    clear: both;
    float: right;
}
</style>



// WEBPACK FOOTER //
// src/components/reception/air/result/result.vue